var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sea-page',{attrs:{"title":"Dettaglio documento","showCompanyHeader":"","back":""}},[_c('doc-preview',{attrs:{"data":_vm.doc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }